import { giroRodaPorDistancia } from '../../dominio/didatico/rolagemRodas'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { Peca } from '../componentes/Peca'
import { TransformacaoPeca } from './contextoDeformacao'
import { RodaLiga3D } from './RodaLiga3D'

export function RodaRealista({ perfil, modoAlvo = false, distanciaRodada = 0 }: { perfil: PerfilVeiculo; modoAlvo?: boolean; distanciaRodada?: number }) {
  const mx = perfil.largura / 2 - perfil.larguraRoda / 2 + 0.02
  return <group>{[-mx, mx].map(x => {
    const rodas = [perfil.eixoDianteiroZ, perfil.eixoTraseiroZ].map(z =>
      <TransformacaoPeca key={z} pecaId={`${z === perfil.eixoDianteiroZ ? 'rodaDianteira' : 'rodaTraseira'}${x > 0 ? 'Esquerda' : 'Direita'}`} ancora={[x, perfil.raioRoda, z]}>
        <group position={[x, perfil.raioRoda, z]} rotation={[0, 0, x > 0 ? Math.PI / 2 : -Math.PI / 2]}>
          <RodaLiga3D raio={perfil.raioRoda} largura={perfil.larguraRoda} simplificada={modoAlvo} giro={giroRodaPorDistancia(distanciaRodada, perfil.raioRoda, Math.sign(x))} />
        </group>
      </TransformacaoPeca>)
    return modoAlvo ? <group key={x}>{rodas}</group> :
      <Peca key={x} id="rodas" deslocamentoAfastado={[Math.sign(x) * 0.45, 0, 0]}>{rodas}</Peca>
  })}</group>
}
